module.exports = __webpack_public_path__ + "static/media/stream_SOLACE_video_classes.4878beb2.svg";